//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../Validate/Validate.AnalysisResult.js";
import "../no/ugmath.js";
let d=[[],[[[],"GetNumOfOptimumOrientations",{R_:{num_of_optimum_orientations:''}},0,0],[["optimum_orientation_index","origin","orientation","num_checker_values","checker_values"],"GetOptimumOrientation",{},1,0],[["checker_index","origin","orientation","num_checker_values","checker_values"],"GetMinimumOrientation",{},1,0]],[]];
SPLM.Validate.PartOrientationAnalysisResult = class extends SPLM.Validate.AnalysisResult{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.PartOrientationAnalysisResult";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.PartOrientationAnalysisResult.CheckerValues = class{
    constructor(m_checker_index,m_checker_min_value,m_checker_value,m_checker_max_value){
        this.m_checker_index=m_checker_index;this.m_checker_min_value=m_checker_min_value;this.m_checker_value=m_checker_value;this.m_checker_max_value=m_checker_max_value;}
    get MCheckerIndex(){return this.m_checker_index}
    set MCheckerIndex(val){this.m_checker_index = val}
    get MCheckerMinValue(){return this.m_checker_min_value}
    set MCheckerMinValue(val){this.m_checker_min_value = val}
    get MCheckerValue(){return this.m_checker_value}
    set MCheckerValue(val){this.m_checker_value = val}
    get MCheckerMaxValue(){return this.m_checker_max_value}
    set MCheckerMaxValue(val){this.m_checker_max_value = val}
};

SPLM.Validate.PartOrientationAnalysisResult.CheckerIndex = Object.freeze({
    "Minimum" : "Minimum", "SurfaceArea" : "SurfaceArea", "SupportVolume" : "SupportVolume", "PrintTime" : "PrintTime", "Overheat" : "Overheat", "Maximum" : "Maximum"});

export default SPLM;